import gql from 'graphql-tag';

export const CreateIncidentCategory = gql`
  mutation CreateIncidentCategory($organizationId: ID!, $request: CreateIncidentCategoryRequest!) {
    createIncidentCategory(organizationId: $organizationId, request: $request) {
      id
      name
      color
    }
  }
`;
